import { useMemo, useState } from "react";
import { Zoom } from "../../PracticeAssessment/Zoom";

export function QuestionImg(props) {
  const [zoom, setZoom] = useState(false);

  const imageURL = useMemo(() => {
    if (!props.image) return null;
    return props.image.startsWith("https://drive.g") ? null : props.image;
  }, [props.image]);

  return imageURL ? (
    <div className="question_image" style={{ position: "relative", flexShrink:0 }}>
      <>
        <img className="q-img" onClick={() => setZoom(true)} src={imageURL} />
        <Zoom image={imageURL} zoom={zoom} close={() => setZoom(false)} />
      </>
    </div>
  ) : null;
}

export function QuestionMedia({ url }) {
  const [zoom, setZoom] = useState(false);

  const mediaType = useMemo(() => {
    if (!url) return null;

    const cleanUrl = url.split("?")[0].toLowerCase();

    if (cleanUrl.match(/\.(jpg|jpeg|png|gif|webp|bmp|svg)$/)) return "image";
    if (cleanUrl.match(/\.(mp4|webm|ogg|mov)$/)) return "video";
    if (cleanUrl.match(/\.(mp3|wav|ogg|aac)$/)) return "audio";

    return null;
  }, [url]);

  if (!url || !mediaType) return null;

  console.log(url, mediaType);

  return (
    <div className="media-wrapper" style={{ position: "relative" }}>
      {mediaType === "image" && (
        <>
          <img
            src={url}
            onClick={() => setZoom(true)}
            style={{ cursor: "pointer", maxWidth: "100%" }}
          />
          <Zoom image={url} zoom={zoom} close={() => setZoom(false)} />
        </>
      )}

      {mediaType === "video" && (
        <video controls style={{ maxWidth: "100%" }}>
          <source src={url} />
          Your browser does not support video.
        </video>
      )}

      {mediaType === "audio" && (
        <audio controls style={{ width: "100%" }}>
          <source src={url} type="audio/mp3"/>
          Your browser does not support audio.
        </audio>
      )}
    </div>
  );
}


export function OptionImg(props) {
  const [zoom, setZoom] = useState(false);
  const imageURL = useMemo(() => {
    if (!props.image) return null;
    return props.image.startsWith("https://drive.g") ? null : props.image;
  }, [props.image]);
  return (
    <div
      className="imgBlock"
      onClick={() => {
        setZoom(!zoom);
      }}
      style={
        props.image
          ? {
              position: "relative",
              background: `url(${imageURL}) no-repeat center center`,
              backgroundSize: "cover",
              cursor: "zoom-in",
            }
          : { display: "none" }
      }
    >
      {imageURL ? (
        <Zoom image={imageURL} zoom={zoom} close={() => setZoom(false)} />
      ) : (
        <></>
      )}
    </div>
  );
}
